module.exports = __webpack_public_path__ + "img/vg.vg2ee2d8b.svg";